import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';

@Component({
    selector: 'ds-banned-inactive-player',
    templateUrl: './banned-inactive-player.component.html',
    styleUrls: ['./banned-inactive-player.component.scss']
})
export class BannedInactivePlayerComponent implements OnChanges {

    @Input() isPlayerActive: boolean;
    @Input() isPlayerBanned: boolean;
    @Input() refreshCount: number;
    @Input() isIdentVerifyFailed: boolean = false;
    @Output() playerRefresh = new EventEmitter();
    displayMessage: string = '';

    constructor() { }
    
    // REFRESH DISPLAY MESSAGES
    ngOnChanges() {
        this.displayMessages();
    }

    // ON CLICK REFRESH PLAYER
    refreshPlayer() {
        this.playerRefresh.emit();
    }

    // CHECK MESSAGES
    displayMessages() {
        if(this.isIdentVerifyFailed) {
            this.displayMessage = 'MODULES.COMMON.MESSAGES.IDENTITY_VERIFICATION_FAILED_MSG';
        } else {
            if(!this.isPlayerActive) {
            this.displayMessage = 'MODULES.COMMON.MESSAGES.PLAYER_ACCOUNT_INACTIVE_ERROR_MSG';
            } 
            if (this.isPlayerBanned) {
                this.displayMessage = this.refreshCount === 1 ? 'MODULES.COMMON.MESSAGES.BANNED_PLAYER_MESSAGE' : 'MODULES.COMMON.MESSAGES.PLAYER_ACCOUNT_BANNED_MSG';
            }
        }
    }
}